
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useEffect, useState } from "react"
import Btn from "../shared/button/Btn"
import { updateCompanyAracItemDocs } from "../../features/companyProfile/companyProfileSlice"
import SmallSpinner from "../shared/spinners/SmallSpinner"
import { showModal } from "../../features/modal/modalSlice"
import { validateFile } from "../../helper/docs/validateFile"
import ImageUploader from "../docs/ImageUploader"

const Container = styled.div`
    width: 100%;

.wrapper{
  display: flex;
  flex-direction: column;
  .content{
    width: 100% !important;
    display: flex;
    flex-direction: column;
    height: auto;
    padding: 0 !important;
   
    
    .top-container{
      width: 100%;

      h4{
        font-size: var(--font-size-md);
        font-weight: var(--font-weight-lg);

      }
    }

    .doc-list{
      display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 30px;
        width: 100%;
        padding: 20px 0;
        overflow: auto;
        height: 500px;
        max-height: 600px;

        .doc-item{
            width: calc(50% - 15px);
            height: 400px;
            border: 1px solid ${({theme}) => theme.mainTextColor};
            border-radius: 10px;
            overflow: hidden;
            
            .doc-item-top{
                width: 100%;
                height: 50px;
                border: 1px solid ${({theme}) => theme.mainBorderColor};
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);

                .action{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;

                        span{

                            &:first-child{
                                width: 60px;
                            }
                        }


                        .delete-btn{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                            /* background-color: var(--color-main); */
                            color: #fff;
                            color: var(--color-main);
                            border: 1px solid var(--color-main);
                            padding: 5px 7px;
                            border-radius: 5px;
                            cursor: pointer;
                            margin-right: 10px;
                            transition: .2s;
                            cursor: not-allowed;

                            &:hover{
                                background-color: var(--color-main);
                                color: #fff;
                            }
                        }
                    }
            }
        }

        .new-select-item{
            border-color: red;
            border-width: 2px;

            .new-select-item-top{
              background-color: #ff000040;
            }
        }
    }

    .btn-container{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 50px;
        width: 100%;
        height: 80px;
        border-top: 1px solid ${({theme}) => theme.mainBorderColor};
    }
  }
}

@media(max-width: 700px){
    .doc-container{
      margin-top: 10px !important;
    }
  }

  @media(max-width: 500px){
    h4{
      font-size: var(--font-size-sm) !important;
      font-weight: var(--font-weight-lg);
    }
  }
`

const ProfileAracDocs = () => {

    const dispatch = useDispatch()

    const {companyAracItem, isLoadingUpdateCompanyAracItemDocs} = useSelector(state => state.companyProfile)

    const [fileList, setFileList] = useState([])


    useEffect(()=> {
      setFileList([
        {
            selectedFile: null,
            loadedBefore: companyAracItem?.ruhsat ? companyAracItem.ruhsat : null,
            fileTypeName: "Ruhsat",
            staticValue: "ruhsat"
        },
        {
            selectedFile: null,
            loadedBefore: companyAracItem?.tasitKartiPhoto ? companyAracItem.tasitKartiPhoto : null,
            fileTypeName: "Taşıt Kartı",
            staticValue: "tasitKartiPhoto"
        },
        {
            selectedFile: null,
            loadedBefore: companyAracItem?.sasePhoto ? companyAracItem.sasePhoto : null,
            fileTypeName: "Şase Fotoğrafı",
            staticValue: "sasePhoto"
        },
        {
            selectedFile: null,
            loadedBefore: companyAracItem?.trafikSigortaPolicePohoto ? companyAracItem.trafikSigortaPolicePohoto : null,
            fileTypeName: "Trafik Sigorta Poliçe",
            staticValue: "trafikSigortaPolicePohoto"
        },
        {
            selectedFile: null,
            loadedBefore: companyAracItem?.yukSigortaPolicePhoto ? companyAracItem.yukSigortaPolicePhoto : null,
            fileTypeName: "Yük Sigorta Poliçe",
            staticValue: "yukSigortaPolicePhoto"
        },
        {
            selectedFile: null,
            loadedBefore: companyAracItem?.aracFotoOndenSuruculu ? companyAracItem.aracFotoOndenSuruculu : null,
            fileTypeName: "Araç Fotoğrafı Önden Sürücülü",
            staticValue: "aracFotoOndenSuruculu"
        },
        {
            selectedFile: null,
            loadedBefore: companyAracItem?.aracFotoOnden ? companyAracItem.aracFotoOnden : null,
            fileTypeName: "Araç Fotoğrafı Önden",
            staticValue: "aracFotoOnden"
        },
        {
          selectedFile: null,
          loadedBefore: companyAracItem?.aracFotoYandan ? companyAracItem.aracFotoYandan : null,
          fileTypeName: "Araç Fotoğrafı Yandan",
          staticValue: "aracFotoYandan"
        },
        {
          selectedFile: null,
          loadedBefore: companyAracItem?.aracFotoArkadan ? companyAracItem.aracFotoArkadan : null,
          fileTypeName: "Araç Fotoğrafı Arkadan",
          staticValue: "aracFotoArkadan"
        },
        {
          selectedFile: null,
          loadedBefore: companyAracItem?.diger1 ? companyAracItem.diger1 : null,
          fileTypeName: "Diğer",
          staticValue: "diger1"
        },  
    ])

    },[companyAracItem])


  const handleFileSelect = async(index, files) => {

      const file = await validateFile({file: files[0], maxSize: 5 * 1024 * 1024, allowedTypes:['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']})
    
      if(file){
        // Tüm kontroller başarılıysa, dosyayı fileList'e ekliyoruz
        const newUploads = [...fileList];
        newUploads[index].selectedFile = file;
        setFileList(newUploads);
      };
  }

  const handleRemoveDoc = () => {}


  const handleSubmit = () => {

    const list = fileList.filter(item => item.selectedFile).map(item => {
      return {
        docName: item.staticValue,
        doc: item.selectedFile
      }
    }) 

    dispatch(updateCompanyAracItemDocs({
      list,
      plate: companyAracItem.truckPlateNumber
    }))
  }

  return (
    <Container>
      <div className="wrapper">
        <div className="content">
         <div className="top-container">
            <h4>Araç Belgeleri</h4>
         </div>

         <div className="doc-list">
         {
                    fileList.map((fileItem, index) => {
                        let previewSrc;
                        let isPdf;
                        if (fileItem.selectedFile) {
                            isPdf = fileItem.selectedFile.type === "application/pdf"
                            previewSrc = URL.createObjectURL(fileItem.selectedFile);

                        } else if (fileItem.loadedBefore) {
                          previewSrc = `${process.env.REACT_APP_API_IMG_URI}${fileItem.loadedBefore}`;
                        } else {
                          previewSrc = "question";
                        }

                        return (
                            <div className={fileItem.selectedFile ? "new-select-item doc-item" : "doc-item"}>
                                 <div className={fileItem.selectedFile ? "new-select-item-top doc-item-top" : "doc-item-top"}>
                                    {fileItem.selectedFile ? (
                                        <p>Yeni Seçilen Belge: {fileItem.selectedFile.name} - ({fileItem.fileTypeName})</p>
                                    ) : fileItem.loadedBefore ? (
                                        <p className="action">
                                            <span></span>
                                            <span>Önceden Yüklenmiş Belge - ({fileItem.fileTypeName})</span>
                                            <button className="delete-btn" onClick={() => handleRemoveDoc(fileItem)}>Belgeyi Sil</button>
                                        </p>
                                    ) : (
                                        <p>Belge Seçilmedi - ({fileItem.fileTypeName})</p>
                                    )}
                                </div>
                                <ImageUploader
                                    previewSrc={previewSrc}
                                    isPdf={isPdf} 
                                    onFileSelect={(files) => handleFileSelect(index, files)} 
                                />
                            </div>
                        )
                    }) 
                }
        </div>
        <div className="btn-container">
            <Btn handleClick={handleSubmit} width={"220px"} bgColor="#E85446" color="#fff" padding="10px" isDisabled={fileList.filter(item => item.selectedFile).length < 1}>{isLoadingUpdateCompanyAracItemDocs ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : fileList.filter(item => item.selectedFile).length < 1 ? "Değişiklik Yok":  `${fileList.filter(item => item.selectedFile).length} Değişiklik Kaydet`}</Btn>
            <Btn handleClick={() => dispatch(showModal(null))} width={"220px"} bgColor="transparent" borderColor="#E85446" color="#E85446" padding="10px">Vazgeç</Btn>
        </div>
        </div>
      </div>
    </Container>
  )
}

export default ProfileAracDocs